// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_mc-0";